import React from 'react';

const ParkingIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
      <g id="surface1">
        <path stroke={'none'} fill={'currentColor'} d="M 32.019531 22.867188 L 27.441406 22.867188 L 27.441406 32.015625 L 32.019531 32.015625 C 34.5 31.957031 36.484375 29.925781 36.484375 27.441406 C 36.484375 24.957031 34.5 22.925781 32.019531 22.867188 Z M 32.019531 22.867188 "/>
        <path stroke={'none'} fill={'currentColor'} d="M 59.460938 0 L 4.574219 0 C 2.046875 0 0 2.046875 0 4.574219 L 0 59.460938 C 0 61.988281 2.046875 64.035156 4.574219 64.035156 L 59.460938 64.035156 C 61.988281 64.035156 64.035156 61.988281 64.035156 59.460938 L 64.035156 4.574219 C 64.035156 2.046875 61.988281 0 59.460938 0 Z M 32.019531 41.164062 L 27.441406 41.164062 L 27.441406 50.3125 L 18.296875 50.3125 L 18.296875 13.722656 L 32.019531 13.722656 C 39.597656 13.722656 45.738281 19.863281 45.738281 27.441406 C 45.738281 35.019531 39.597656 41.164062 32.019531 41.164062 Z M 32.019531 41.164062 "/>
      </g>
    </svg>
  );
};

export default ParkingIcon;
